import { createSlice } from "@reduxjs/toolkit";
import states from "../states";

export const companyReducer = createSlice({
	name: "companyReducer",
	initialState: { ...states?.companyDetails },
	reducers: {},
});
